import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';
import { AuthApiRoutes } from './auth-api.routes';
import { AuthService } from './auth.service';
import { NotificationService } from '../../shared/services/notification.service';

export const authResponseInterceptor: HttpInterceptorFn = (request, next) => {
  const auth = inject(AuthService);
  const router = inject(Router);
  const notifications = inject(NotificationService);

  return next(request).pipe(
    catchError((error: unknown) => {
      if (error instanceof HttpErrorResponse && error.status === 401) {
        const isCurrentUserProbe = request.url.endsWith(AuthApiRoutes.CurrentUser);

        if (isCurrentUserProbe) {
          return throwError(() => error);
        }

        auth.clearCurrentUser();

        if (!request.url.endsWith(AuthApiRoutes.Login)) {
          notifications.error(error);
          const returnUrl = router.url !== '/login' ? router.url : '/';
          void router.navigate(['/login'], { queryParams: { returnUrl } });
        }
      } else if (error instanceof HttpErrorResponse && error.status === 403) {
        notifications.error(error);
      }

      return throwError(() => error);
    }),
  );
};
